module.exports = [{"guest_id":"f4402254-f0f5-425e-9a04-720f5371c6e7","user_id":"42309127-f038-4a02-a730-d2d3d0446a15","guest_name":"Andrew","timestamp":"2018-06-29T19:54:54.517Z","pin":"1234"},{"guest_id":"7013904b-02a6-4cd7-9112-5a8722086daf","user_id":"42309127-f038-4a02-a730-d2d3d0446a15","timestamp":"2018-06-30T15:54:54.517Z","guest_name":"Paul","pin":"5678"},{"guest_id":"12a12ee8-d455-4e8c-9a08-4cf7b1eba7fb","user_id":"42309127-f038-4a02-a730-d2d3d0446a15","guest_name":"Cruise","timestamp":"2018-06-10T19:54:54.517Z","pin":"9012"}]


//////////////////
// WEBPACK FOOTER
// ./src/util/guest.json
// module id = 263
// module chunks = 0